import { Box, Typography } from "@mui/material";

function formatDescription(text) {
  const lines = String(text || "").split("\n");

  return lines.map((line, lineIndex) => {
    const parts = line.split(/(\*[^*]+\*)/g).filter(Boolean);

    return (
      <Typography
        key={lineIndex}
        sx={{
          fontSize: { xs: 15.2, md: 16.4 },
          fontWeight: 500,
          color: "#374151",
          lineHeight: 1.85,
          mb: lineIndex === lines.length - 1 ? 0 : 1.15,
          whiteSpace: "pre-wrap",
        }}
      >
        {parts.map((part, partIndex) => {
          const isBold = /^\*[^*]+\*$/.test(part);

          if (isBold) {
            return (
              <Box component="strong" key={partIndex} sx={{ fontWeight: 700, color: "#111827" }}>
                {part.slice(1, -1)}
              </Box>
            );
          }

          return <Box component="span" key={partIndex}>{part}</Box>;
        })}
      </Typography>
    );
  });
}

export default function StoreProductDescription({ description }) {
  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#ffffff",
        border: "1px solid #e5e7eb",
        borderRadius: "32px",
        px: { xs: 2.2, md: 3.2 },
        py: { xs: 2.2, md: 2.8 },
        minHeight: 220,
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: 20, md: 25 },
          fontWeight: 700,
          color: "#111827",
          mb: 1.8,
        }}
      >
        Descripción
      </Typography>

      {description ? (
        <Box>{formatDescription(description)}</Box>
      ) : (
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 500,
            color: "#6b7280",
            lineHeight: 1.8,
          }}
        >
          Este producto no tiene descripción disponible.
        </Typography>
      )}
    </Box>
  );
}